import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@/utils/httpClient';

export interface DailyTransactionMetrics {
  metric_date: string;
  turn_ins_today: number;
  exchanges_today: number;
  issues_today: number;
  front_window_customer_count: number;
  front_window_transaction_count: number;
  csr: number;
}

const getSiteLocalDate = (): string =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());

export const useDailyTransactionMetrics = () => {
  return useQuery({
    queryKey: ['daily-transaction-metrics'],
    queryFn: async (): Promise<DailyTransactionMetrics> => {
      // PostgREST returns an array; we expect exactly one row from the view
      const result = await httpClient.get<DailyTransactionMetrics[]>(
        '/api/v1/daily_transaction_metrics',
      );
      const row = result?.[0];
      if (!row) {
        return {
          metric_date: getSiteLocalDate(),
          turn_ins_today: 0,
          exchanges_today: 0,
          issues_today: 0,
          front_window_customer_count: 0,
          front_window_transaction_count: 0,
          csr: 0,
        };
      }
      return row;
    },
    staleTime: 60 * 1000, // 1 minute - daily status metrics can be slightly stale
  });
};
